import { TOOLBAR } from "../contents/actionTypes";


const toolbar = (state = true , action) => {

    switch (action.type)
    {

        case TOOLBAR:
        {
            return action.show
        }



        default:
            return state
    }
}


export default toolbar;